export default state => {
    return state.items;
}